<template>
  <div>
    <b-button style="width: 40%; display: inline;" class="dark-btn start-enrollment-container mx-1" @click="startNewEnrollment()">Start New Enrollment</b-button>
    <b-button style="width: 50%; display: inline;" class="button-brand  continue-enrollment-container mx-1" @click="$bvModal.hide('code-send')">Continue Current Enrollment</b-button>
  </div>
</template>

<script>
export default {
  name: "saveAndContinueOption",
  methods: {
    startNewEnrollment () {
      let app = this;
      window.localStorage.removeItem("tempId");
      window.localStorage.removeItem("cartCount");
      app.$bus.$emit("resetCartInfo");
      app.$router.push({ name: 'main' });
    }
  }
}
</script>

<style scoped>
.start-enrollment-container {
  padding: 12px 18px !important;
}
.continue-enrollment-container {
  padding: 12px 14px !important;
}
@media (max-width: 767px) {
  .start-enrollment-container {
    margin-top: -17px;
  }
}
</style>